import { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { useSmartResizeObserver } from "components/workspaces/hooks/use-smart-resize-observer";
import { ConditionalVisibility } from "store/current-dashboard/types";
export const useResizeHighchart = (highchartRef, containerRef, uniqueKey) => {
    const { height, width } = useSmartResizeObserver(containerRef, uniqueKey);
    useLayoutEffect(() => {
        const chart = highchartRef?.current?.chart;
        if (chart) {
            chart.setSize(width, height, false);
        }
    }, [highchartRef, height, width]);
};
export const useConditionalVisibility = () => {
    const conditionalVisibility = useSelector((state) => (state.currentDashboard.dashboardOptions?.enabled
        ? ConditionalVisibility.myPositionsOnly
        : ConditionalVisibility.wholeFundOnly));
    return conditionalVisibility;
};
